<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{$t('profile.material.colors')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <MaterialColorForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import MaterialColorForm from '../../components/materialcolor/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'MaterialColor';

const { mapFields } = createHelpers({
  getterType: 'materialcolor/getField',
  mutationType: 'materialcolor/updateField'
});

export default {
  name: 'MaterialColorCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    MaterialColorForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('materialcolor', ['create', 'reset'])
  }
};
</script>
